import { computed, toValue } from 'vue';
import { ComputeEngine } from '@cortex-js/compute-engine';

export function useComputeEngine(latex) {
    const ce = new ComputeEngine();

    const canonical = computed(() => {
        const expression = ce.parse(toValue(latex));

        if (!expression.isValid) {
            return null;
        }
        return expression.toLatex();
    });

    return {
        canonical,
    };
}
